/**
 * Debug logger utility that only logs in development environment
 * @param {string} message - The message to log
 * @param {...any} args - Additional arguments to log
 */
const debugLogger = (message, ...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(message, ...args)
  }
}

export default debugLogger
